import { CUSTOM_JSON_COMPONENT_TYPES } from '@apps/websiteCustomJsonComponents/config';
import { JsonDataBlobComponentFragment } from '@graphql/generated';
import React from 'react';

type GuestJsonComponentWrapperProps = {
  jsonComponentData: JsonDataBlobComponentFragment;
};

export const GuestSiteCustomJsonComponentWrapper = (props: GuestJsonComponentWrapperProps) => {
  const { jsonComponentData } = props;
  const data = jsonComponentData.containerContent;

  const Component =
    CUSTOM_JSON_COMPONENT_TYPES.find(c => c.schemaUrl === data.schemaUrl)?.guestSiteComponent ||
    CUSTOM_JSON_COMPONENT_TYPES.find(c => c.componentType === data.type)?.guestSiteComponent;

  if (Component) {
    return (
      <Component
        {...props}
        data={data}
      />
    );
  }

  return null;
};
